import * as React from 'react';

export default function condition({small}){
    return(
        <>
        <h6>
            ข้อกำหนดและเงื่อนไขในการใช้บริการ HubSwitch Pro ฉบับนี้ (“ข้อกำหนดและเงื่อนไข”) ได้ระบุถึงข้อกำหนดและเงื่อนไขในการใช้งานผลิตภัณฑ์และบริการต่าง ๆ (เรียกรวมกันว่า “บริการฯ”) บนแอปพลิเคชัน/ซอฟต์แวร์ที่มีชื่อว่า “HubSwitch Pro” (“HubSwitch Pro”) ของบริษัท ฮับสวิตช์ จำกัด (“บริษัทฯ” หรือ “เรา”)  เพื่อให้ผู้ใช้บริการ (โดยแต่ละรายจะเรียกว่า “ท่าน”) รับทราบและเข้าใจถึงเงื่อนไขและข้อปฏิบัติในการเข้าใช้งานบริการต่าง ๆ ที่บริษัทฯ มีให้เลือกใช้บน HubSwitch Pro โดยข้อกำหนดและเงื่อนไขฉบับนี้จะมีผลผูกพันกับท่านนับตั้งแต่ บริษัทฯ อนุญาตให้ท่านเข้าถึงบริการที่มีอยู่บน HubSwitch Pro ดังนั้น โปรดอ่านเงื่อนไขการใช้บริการโดยละเอียดเพื่อประโยชน์ในการรับบริการ

 
            </h6><h6>
บริษัทฯ ขอสงวนสิทธิ์ในการใช้ดุลพินิจแต่เพียงฝ่ายเดียวที่จะแก้ไข เปลี่ยนแปลง เพิ่มเติมตัดทอน ข้อกำหนดและเงื่อนไขฉบับนี้ตามที่บริษัทฯ เห็นสมควรเป็นครั้งคราวโดยไม่ต้องแจ้งให้ท่านทราบล่วงหน้า ท่านมีหน้าที่ติดตามการแก้ไขเปลี่ยนแปลงต่าง ๆ อยู่เสมอด้วยตัวท่านเอง ทั้งนี้ หากภายหลังการแก้ไขเปลี่ยนแปลงดังกล่าวแล้ว ท่านยังคงใช้บริการหรือเข้าใช้ HubSwitch Pro อยู่ ถือว่าท่านได้ตกลงยอมรับตามข้อกำหนดและเงื่อนไขที่ได้มีการเปลี่ยนแปลงนั้นแล้วอย่างไม่มีเงื่อนไขและท่านไม่อาจอ้างเหตุในการไม่ทราบถึงการเปลี่ยนแปลงดังกล่าวมาเป็นเหตุในการฝ่าฝืนข้อกำหนดและเงื่อนไขฉบับนี้และฉบับที่มีการแก้ไขได้ ทั้งนี้ บริษัทฯ จะดำเนินการอย่างสุดความสามารถเพื่อแจ้งให้ท่านทราบถึงการเปลี่ยนแปลงดังกล่าวผ่านช่องทางการสื่อสารต่าง ๆ เช่น อีเมล หรือหน้าเว็บไซต์ของบริษัทฯ โดยถือเป็นหน้าที่ของท่านในการอ่านและทำความเข้าใจเงื่อนไขการบริการล่าสุดที่ปรากฏบนหน้าเว็บไซต์

 
</h6><h6>
การตกลงสมัครเข้าใช้บริการบน HubSwitch Pro นั้นถือว่าเป็นการยอมรับว่าท่านได้อ่านและเข้าใจข้อกำหนดและเงื่อนไขฉบับนี้โดยละเอียดถี่ถ้วน และท่านยอมรับเงื่อนไขการใช้บริการทุกประการ โดยข้อกำหนดและเงื่อนไขฉบับนี้มีผลผูกพันผู้ใช้บริการตามกฎหมาย

 
</h6><h6>
1. คำจำกัดความ

 
</h6><h6>
“ข้อกำหนดและเงื่อนไข” หมายถึง เงื่อนไขและข้อกำหนดการใช้บริการ HubSwitch Pro

 
</h6><h6>
“ค่าบริการ” หมายถึง ค่าบริการรายเดือน หรือ รายปี ที่ท่านมีหน้าที่ต้องชำระตามรอบการเรียกชำระค่าบริการที่กำหนดโดยบริษัทฯ ตามตารางอัตราค่าธรรมเนียมที่ได้แจ้ง

 
</h6><h6>
“ข้อมูล” หมายถึง ข้อมูลใด ๆ ที่ท่านหรือผู้มีอำนาจของท่าน ได้ให้ไว้แก่ทางบริษัทฯ ไม่ว่าจะผ่านช่องทางใดก็ตาม

 
</h6><h6>
“ข้อมูลที่เป็นความลับ” หมายถึง ข้อมูลต่าง ๆ ที่ท่านหรือบริษัทฯ ได้ให้ไว้แก่กัน ไม่ว่าจะด้วยลายลักษณ์อักษร ทางอิเล็กทรอนิกส์ หรือทางวาจา รวมถึงการบริการที่มีให้โดยบริษัทฯ อย่างไรก็ตาม ข้อมูลที่เป็นความลับนั้นไม่รวมถึงข้อมูลใด ๆ ที่ได้ถูกเผยแพร่สู่สาธารณชนเป็นที่เรียบร้อยแล้ว

 
</h6><h6>
“ตารางอัตราค่าธรรมเนียม” หมายถึง ข้อมูลที่เกี่ยวข้องกับการสมัครสมาชิกและการเรียกชำระค่าบริการที่กำหนดไว้ในการสมัครใช้บริการต่าง ๆ บน HubSwitch Pro โดยบริษัทฯ อาจมีการปรับปรุงหรือแก้ไขเพิ่มเติม เป็นครั้งคราวได้ตลอดระยะเวลาการให้บริการ อัตราค่าธรรมเนียมการบริการที่แสดงจะรวมภาษีมูลค่าเพิ่มแล้ว

 
</h6><h6>
“ทรัพย์สินทางปัญญา” หมายถึง สิทธิบัตร, เครื่องหมายการค้า, เครื่องหมายบริการ, ลิขสิทธิ์, สิทธิโดยธรรม, สิทธิในแบบผลิตภัณฑ์,  ทรัพย์สินทางปัญญาอื่น ๆ ที่อยู่ในรูปแบบของ ซอฟต์แวร์(Software), อุปกรณ์(Hardware), แบบร่าง, โปรแกรม, แผนผัง, ระบบ, ขั้นตอนการทำงาน, โลโก้ ไม่ว่าจะได้จดทะเบียนไว้ต่อเจ้าหน้าที่แล้วหรือไม่ก็ตาม

 
</h6><h6>
“การให้บริการ” หมายถึง การให้บริการซอฟต์แวร์สำหรับการจัดการธุรกิจร้านเสริมสวยผ่านการใช้งาน HubSwitch Pro

 
</h6><h6>
“ผู้ใช้งานในระบบ” หมายถึง บุคคลหรือบริษัทอื่นใดที่มิใช่ผู้ใช้บริการแต่ได้รับมอบอำนาจจากผู้ใช้บริการให้สามารถเข้าใช้บริการในนามของตัวผู้ใช้บริการที่เป็นคู่สัญญากับบริษัทฯ

 
</h6><h6>
“ท่าน” หมายถึง ผู้ใช้บริการที่มีอยู่บน HubSwitch Pro และผู้ที่เป็นคู่สัญญากับบริษัทฯ ทั้งนี้ ไม่รวมถึง ผู้ใช้งานในระบบ

 
</h6><h6>
“บริษัทฯ” หรือ “เรา” หมายถึง บริษัท ฮับสวิตซ์ จำกัด

 
</h6><h6>
“เว็บไซต์” หมายถึง https://hubswitch.com หรือเว็บไซต์อื่น ๆ ที่ดำเนินการโดยบริษัทฯ

 
</h6><h6>
“HubSwitch Pro” หมายถึง แอปพลิเคชัน/ซอฟต์แวร์ ที่มีชื่อว่า “HubSwitch Pro” และเว็บไซต์ที่ให้บริการโดยบริษัท ฮับสวิตซ์ จำกัด

 
</h6><h6>
“เหตุสุดวิสัย” หมายถึง เหตุการณ์หรือผลของเหตุการณ์ที่เกิดขึ้นโดยเป็นเหตุที่ไม่อาจป้องกันได้ แม้บุคคลผู้ต้องประสบหรือใกล้จะต้องประสบเหตุนั้น จะได้จัดการระมัดระวังตามสมควรอันพึงคาดหมายได้จากบุคคลในฐานะและภาวะเช่นนั้น

 
</h6><h6>
2. การสร้างบัญชีสมาชิก

 
</h6><h6>
ในการเข้าใช้งานหรือใช้บริการบน HubSwitch Pro ท่านจะต้องส่งคำขอลงทะเบียนเป็นผู้ใช้บริการมายังบริษัทฯผ่านหน้าเว็บไซต์ HubSwitch Pro หรือช่องทางอื่นใดที่บริษัทฯ ได้กำหนดและท่านตกลงว่าบริษัทฯ อาจใช้ข้อมูลที่ได้รับจากท่านเพื่อให้บริการท่านในการเข้าถึง ใช้ หรือ การอื่นใดตามที่กำหนดไว้ภายใต้ข้อกำหนดและเงื่อนไขฉบับนี้ ในการใช้งานบริการบน HubSwitch Pro ข้อมูลทั้งหมดที่ท่านให้กับเราในระหว่างการลงทะเบียนจะต้องเป็นข้อมูลที่ถูกต้อง ครบถ้วน และเป็นปัจจุบัน นอกจากนี้ ท่านตกลงที่จะรักษาและอัปเดตข้อมูลของท่านบน HubSwitch Pro ตลอดระยะเวลาที่ท่านใช้งาน ท่านรับทราบว่าข้อมูลเท็จใด ๆ ที่ท่านให้ไว้กับบริษัทฯ จะทำให้บริษัทฯ สามารถยุติบัญชีสมาชิกของท่านและข้อกำหนดและเงื่อนไขฉบับนี้ รวมถึงระงับการใช้งานบน HubSwitch Pro ของท่าน นอกจากนี้ บริษัทฯ ขอสงวนสิทธิ์ในการปฏิเสธคำขอลงทะเบียนใด ๆ ที่ไม่เป็นไปตามเกณฑ์การประเมินของบริษัทฯ และบริษัทฯ ไม่มีภาระผูกพันใด ๆ ในการเปิดเผยหลักเกณฑ์ดังกล่าว

 
</h6><h6>
ท่านมีหน้าที่ในการรักษาความลับของชื่อบัญชีผู้ใช้และรหัสผ่านในการเข้าสู่ HubSwitch Pro ของท่าน (รวมถึงผู้ได้รับอนุญาตให้ใช้งาน) และท่านตกลงที่จะรับผิดชอบต่อกิจกรรมทั้งหมดที่เกิดขึ้นภายใต้การใช้งานบัญชีผู้ใช้นั้น โดยบริษัทฯ จะพยายามใช้มาตรการรักษาความปลอดภัยที่เหมาะสมเพื่อป้องกันการเข้าถึงบัญชีของท่านโดยไม่ได้รับอนุญาต อย่างไรก็ตาม บริษัทฯ ไม่รับประกันความปลอดภัยอย่างสมบูรณ์ต่อบัญชีของท่านและข้อมูลใด ๆ ที่ท่านให้ไว้ผ่านการใช้งานบริการ HubSwitch Pro และบริษัทฯ ไม่รับประกันว่าการรักษาความปลอดภัยของบริษัทฯ จะสามารถป้องกันแฮ็กเกอร์บุคคลภายนอกจากการเข้าถึง HubSwitch Pro อย่างผิดกฎหมายหรือโดยไม่ได้รับอนุญาต นอกจากนี้ ท่านตกลงที่จะแจ้งให้บริษัทฯ ทราบทันทีเมื่อบัญชีของท่านถูกนำไปใช้โดยไม่ได้รับอนุญาตหรือการละเมิดความปลอดภัยอื่น

 
</h6><h6>
3. การให้บริการ

 
</h6><h6>
3.1 HubSwitch Pro เป็นเพียงเสมือนเครื่องมือที่มีวัตถุประสงค์เพื่อช่วยเหลือและเพิ่มความสะดวกสบายให้แก่ท่านในการจัดการบัญชีร้านให้บริการของท่าน และการบริหารจัดการทางทางธุรกิจต่าง ๆ ที่สามารถอำนวยความสะดวกให้ท่านในการดำเนินธุรกิจ เท่านั้น บริษัทฯ มิได้ให้บริการในฐานะผู้เชี่ยวชาญด้านการบัญชี ดังนั้นหากท่านต้องการคำปรึกษาทางด้านปัญหาบัญชีหรือการบริหารจัดการทางธุรกิจ โปรดปรึกษาจากผู้เชี่ยวชาญของท่านโดยตรง  บริษัทฯ ขอสงวนสิทธิในการไม่ตอบคำถามหรือให้คำแนะนำใด ๆ เกี่ยวกับปัญหาเรื่องดังกล่าว รวมถึงไม่ขอรับผิดชอบจากคำปรึกษาที่ท่านอาจได้รับใด ๆ ทั้งสิ้น

 
</h6><h6>
3.2 แพ็กเกจและรูปแบบการให้บริการต่าง ๆ ของ HubSwitch Pro นั้นจะเป็นไปตามรายละเอียดที่ปรากฏบนหน้าเว็บไซต์ของบริษัทฯ และ ที่แสดงอยู่บน HubSwitch Pro

 
</h6><h6>
3.3 บริษัทฯ ให้สิทธิท่านในการใช้บริการ HubSwitch Pro ผ่านทางเว็บไซต์ตามแพ็กเกจการใช้บริการที่ท่านได้เลือกไว้ โดยสิทธิดังกล่าวนี้มิใช่สิทธิเด็ดขาด และไม่สามารถโอนไปให้บุคคลหรือบริษัทอื่นใช้งานได้และอยู่ภายใต้ข้อกำหนดเงื่อนไขการใช้ฉบับนี้

 
</h6><h6>
3.4 ท่านมีสิทธิมอบหมายให้บุคคลหรือบริษัทใด ๆ เป็นผู้ใช้งานในระบบเพื่อเข้าจัดการบัญชีผู้ใช้งาน HubSwitch Pro ได้ตามจำนวนที่สอดคล้องกับแพ็กเกจการให้บริการที่ท่านเลือกใช้ โดยท่านจะต้องรับผิดชอบต่อการกระทำใด ๆ ก็ตามที่ผู้ใช้งานในระบบได้กระทำลงเสมือนกับเป็นการกระทำของท่านเอง ไม่ว่าการกระทำดังกล่าวจะอยู่ในความรับรู้ของท่านหรือไม่ก็ตาม และหากการกระทำของผู้ใช้งานในระบบก่อให้เกิดความเสียหายหรือการเสียผลประโยชน์แก่ท่าน บริษัทฯ จะไม่รับผิดชอบใด ๆ ทั้งสิ้น

 
</h6><h6>
3.5 ท่านมีสิทธิเด็ดขาดในการเปลี่ยนแปลง จำกัด หรือยกเลิกการใช้งานของผู้ใช้งานในระบบที่ท่านได้กำหนดไว้ได้ตามที่ท่านเห็นสมควร ในกรณีที่มีข้อพิพาทเกิดขึ้นระหว่างท่านและผู้ใช้งานในระบบบริษัทฯ จะปฏิบัติตามคำร้องขอหรือคำสั่งของท่านแต่เพียงผู้เดียวในฐานะคู่สัญญาของบริษัทฯ

 
</h6><h6>
3.6 บริษัทฯ ขอสงวนสิทธิในการไม่ดำเนินการตามคำร้องขอหรือคำสั่งใด ๆ จากบุคคลภายนอก ไม่ว่าจะเป็นผู้ใช้งานในระบบที่ท่านเลือกให้สามารถเข้าใช้งานหรือตัวแทนผู้รับมอบอำนาจของท่านก็ตาม เว้นแต่จะปรากฏให้บริษัทฯ เห็นว่าท่านได้ให้ความยินยอมชัดแจ้งแก่ทางบริษัทฯ เป็นลายลักษณ์อักษร

 
</h6><h6>
4. การชำระค่าบริการและค่าธรรมเนียม

 
</h6><h6>
ระยะเวลาของรอบการเรียกเก็บค่าบริการหรือค่าธรรมเนียมจะขึ้นอยู่กับประเภทการสมัครสมาชิกที่ท่านเลือกใช้บน HubSwitch Pro เมื่อท่านได้สมัครใช้บริการ หากท่านไม่แสดงเจตนาเลิกใช้บริการตามวิธีการที่บริษัทฯ ได้กำหนดไว้ภายใต้เงื่อนไขและข้อกำหนดฉบับนี้ ก่อนสิ้นสุดระยะเวลาในการใช้บริการ ระยะเวลาในการใช้บริการจะถูกขยายออกไปโดยอัตโนมัติออกไปอีกหนึ่งรอบการเรียกชำระค่าบริการจนกว่าท่านจะขอยกเลิกการขอใช้บริการกับบริษัทฯ

 
</h6><h6>
ในส่วนที่เกี่ยวข้องกับข้อมูลด้านเครือข่ายการชำระเงินออนไลน์นั้น บริษัทฯ จะมีการดำเนินการให้ท่านโดยไม่มีการเรียกเก็บค่าใช้จ่าย อย่างไรก็ตาม บริษัทฯ ขอสงวนสิทธิในการส่งผ่านค่าใช้จ่ายใด ๆ ที่เกี่ยวข้อง ทั้งนี้ ทางผู้ให้บริการระบบและเครือข่ายการชำระเงินออนไลน์อาจมีการเรียกเก็บค่าบริการจากท่านเพิ่มเติมตามนโยบายของบริษัท โดยท่านสามารถศึกษารายละเอียดเพิ่มเติมของผู้ให้บริการเครือข่ายการชำระเงินออนไลน์ได้ที่ https://moneyspace.net/portal/privacy ทั้งนี้ ท่านมีสิทธิในการตัดสินใจที่จะยุติการใช้เครือข่ายการชำระเงินออนไลน์ได้ทุกเมื่อ โดยท่านจะต้องดำเนินการแจ้งล่วงหน้าอย่างเหมาะสมให้ บริษัทฯ ทราบถึงเครือข่ายการชำระเงินออนไลน์ที่ท่านต้องการยุติ เมื่อได้รับการแจ้งให้ทราบล่วงหน้าแล้ว บริษัทฯ จะจัดการยกเลิกช่องทางการชำระเงินออนไลน์ดังกล่าว

 
</h6><h6>
5. หน้าที่และความรับผิดชอบของผู้ใช้บริการ

</h6><h6>

โดยการใช้ HubSwitch Pro ท่านตกลงที่จะปฏิบัติตามเงื่อนไขดังต่อไปนี้

</h6><h6>

(ก) ท่านจะต้องให้ข้อมูลใด ๆ ที่เกี่ยวข้องกับการใช้บริการ HubSwitch Pro ของท่านตามความเป็นจริงและรับประกันว่าข้อมูลที่ให้นั้นถูกต้อง สมบูรณ์ และเป็นปัจจุบันเสมอ

</h6><h6>

(ข) ท่านให้การรับประกันว่าที่ท่านได้ลงทะเบียนเพื่อใช้บริการในนามของบุคคลอื่น ท่านมีอำนาจที่จะยอมรับข้อกำหนดและเงื่อนไขฉบับนี้ในนามของบุคคลนั้นและยอมรับว่าการลงทะเบียนเพื่อใช้บริการใด ๆ บน HubSwitch Pro ได้ผูกพันบุคคลที่ท่านได้ดำเนินการแทนดังกล่าว

</h6><h6>

(ค) ท่านตกลงที่จะใช้ HubSwitch Pro เพื่อจุดประสงค์ที่ได้รับอนุญาตภายใต้ข้อกำหนดและเงื่อนไขฉบับนี้ กฎหมายและข้อบังคับที่เกี่ยวข้องเท่านั้น

</h6><h6>

(ง) ท่านตกลงที่จะแจ้งให้บริษัทฯ ทราบโดยทันทีเกี่ยวกับการเข้าใช้งาน HubSwitch Pro โดยไม่ได้รับอนุญาตหรือการละเมิดความปลอดภัยของ HubSwitch Pro ที่ท่านได้รับทราบ

</h6><h6>

(จ) ท่านตกลงที่จะไม่ใช้ เผยแพร่ ส่งต่อ แจกจ่ายหรือจัดเก็บเนื้อหา ข้อมูล หรือข้อมูลใด ๆ ที่ผิดกฎหมายหรือเผยแพร่ในสิ่งที่ไม่เกี่ยวข้องกับการใช้บริการบน HubSwitch Pro ซึ่งรวมถึงแต่ไม่จำกัดเพียง เสนอขายสินค้าหรือบริการ อีเมลโฆษณาไม่พึงประสงค์ ข้อมูลที่อาจสร้างความเสียหายต่ออุปกรณ์คอมพิวเตอร์หรือซอฟต์แวร์ของผู้ใช้บริการหรือบุคคลท่านอื่น ๆ เนื้อหาที่อาจสร้างความไม่พอใจใด ๆ ต่อผู้ใช้บริการหรือเว็บไซต์รายอื่น หรือวัตถุหรือข้อมูลที่จะเป็นการละเมิดกฎหมายใด ๆ (รวมถึงข้อมูลและวัตถุอื่นใดที่ได้รับความคุ้มครองลิขสิทธิ์หรือความลับทางการค้าซึ่งท่านมิได้มีสิทธิที่จะใช้) ท่านต้องใช้ความระมัดระวังเมื่อใช้เครื่องมือสื่อสารที่มีอยู่บนเว็บไซต์ อย่างไรก็ตาม บริษัทฯ ขอสงวนสิทธิ์ในการลบการสื่อสารใด ๆ ที่เกิดขึ้นบน HubSwitch Pro ได้ตลอดเวลาตามดุลยพินิจของบริษัทฯ

</h6><h6>

(ฉ) ท่านตกลงที่จะไม่ใช้ คัดลอก แก้ไข สร้างงานลอกเลียนแบบ วิศวกรรมย้อนกลับ ถอดรหัสหรือพยายามกระทำการในลักษณะใด ๆ ที่จะส่งผลกระทบต่อการทำงานหรือการทำงานของ HubSwitch Pro หรือ เว็บไซต์อื่นที่เกี่ยวข้อง ๆ ของบริษัทฯ

</h6><h6>

(ช) ท่านตกลงจะไม่ใช้บริการ HubSwitch Pro ในทางที่ผิดประเภทซึ่งอาจบั่นทอนประสิทธิภาพการทำงานของ HubSwitch Pro เว็บไซต์ หรือระบบอื่น ๆ ที่เกี่ยวข้องกับการบริการของบริษัทฯ

</h6><h6>

(ซ) ท่านตกลงจะไม่พยายามเข้าถึงเนื้อหาส่วนใด ๆ นอกเหนือจากที่ท่านได้รับอนุญาตอย่างชัดเจนในการเข้าถึงหรือระบบคอมพิวเตอร์ที่เกี่ยวข้องกับ HubSwitch Pro

</h6><h6>

(ฌ) ท่านตกลงจะไม่ส่งหรือป้อนสิ่งอื่นใดลงบน HubSwitch Pro หรือเว็บไซต์ของบริษัทฯ ซึ่งอาจสร้างความเสียหายต่ออุปกรณ์คอมพิวเตอร์หรือซอฟต์แวร์ของบุคคลอื่น ๆ  เนื้อหาที่อาจสร้างความไม่พอใจ หรือวัตถุหรือข้อมูลที่จะเป็นการละเมิดต่อกฎหมาย

</h6><h6>

(ญ) ท่านรับทราบว่าข้อมูลต่าง ๆ บนเว็บไซต์และบริการอาจสามารถสูญหายได้เนื่องจากเหตุผลทางด้านเทคนิค หรือการถูกโจมตีจากบุคคลภายนอก ดังนั้น ท่านมีหน้าที่ที่จะต้องสำรองข้อมูลหรือทำการคัดลอกข้อมูลหรือเอกสารใด ๆ ที่ท่านส่งเข้ามาในระบบด้วยตัวท่านเองอีกทางหนึ่ง ในการนี้ท่านตกลงว่า HubSwitch Pro ไม่มีหน้าที่ต้องรับผิดชอบต่อการสูญหายของข้อมูลไม่ว่าการสูญหายของข้อมูลดังกล่าวจะเกิดขึ้นด้วยเหตุใดก็ตาม

</h6><h6>

(ฎ) ท่านต้องรับผิดชอบต่อค่าใช้จ่ายหรือการชำระเงินใด ๆ ที่เกิดขึ้นจากการเลือกใช้และตอบรับการให้บริการบน HubSwitch Pro

</h6><h6>

(ฏ) ท่านตกลงที่จะไม่แทรกแซงหรือหลีกเลี่ยงคุณลักษณะด้านความปลอดภัยของ HubSwitch Pro

</h6><h6>

หากบริษัทฯ ตรวจพบว่าท่านกระทำการฝ่าฝืนข้อกำหนดข้อใดข้อหนึ่งข้างต้น บริษัทฯ ขอสงวนสิทธิในการยกเลิกบัญชีสมาชิกที่ท่านใช้บริการของท่านและยุติการให้บริการ HubSwitch Pro ในทันทีโดยไม่ต้องแจ้งท่านให้ทราบล่วงหน้า

</h6><h6>

6. การชดใช้ค่าเสียหาย

</h6><h6>

ท่านจะชดใช้ค่าเสียหายให้กับบริษัทฯ สำหรับ ค่าสินไหมทดแทน ค่าใช้จ่าย ความเสียหายและความสูญเสียทั้งหมดที่เกิดขึ้นจากการละเมิดในข้อหนึ่งข้อใดของข้อกำหนดและเงื่อนไขฉบับนี้ รวมถึงค่าใช้จ่ายใด ๆ ที่เกี่ยวข้องกับค่าธรรมเนียมการเข้าถึงช่องทางการให้บริการใด ๆ ที่ครบกำหนดแต่ยังมิได้รับการชำระจากท่าน

</h6><h6>

7. การคุ้มครองข้อมูลส่วนบุคคล

</h6><h6>

บริษัทฯ จะเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลของท่านที่ท่านได้ให้แก่บริษัทฯ ด้วยความระมัดระวัง และเป็นไปตามมาตรฐานที่กำหนดไว้ในนโยบายความเป็นส่วนตัวของบริษัทฯ ซึ่งถือเป็นส่วนหนึ่งของข้อกำหนดและเงื่อนไขการให้บริการฉบับนี้ ท่านสามารถศึกษาเพิ่มเติมนโยบายความเป็นส่วนตัวของบริษัทฯ ได้ที่ [•]

</h6><h6>

8. ทรัพย์สินทางปัญญา

</h6><h6>

8.1 บริษัทฯ เป็นเจ้าของลิขสิทธิ์ และ ทรัพย์สินทางปัญญาในข้อมูลที่แสดง รูปภาพ และ รูปแบบการแสดงผล ตามที่ปรากฏใน HubSwitch Pro ทั้งหมด รวมถึงเอกสาร ข้อความ ซอฟต์แวร์ กราฟิก ภาพถ่าย เสียง เพลง วิดีโอ ข้อมูลที่รวบรวมบน HubSwitch Pro และเนื้อหาอื่น ๆ ยกเว้นจะมีการระบุอย่างชัดเจนไว้เป็นอื่น

</h6><h6>

8.2 บริษัทฯ ไม่ได้เป็นเจ้าของข้อมูลหรือเนื้อหาใด ๆ (“เนื้อหา”) ที่ท่านได้ให้ไว้บนเว็บไซต์เพื่อการใช้งานใช้บริการ ท่านจะต้องเป็นผู้รับผิดชอบต่อความถูกต้อง คุณภาพ ความสมบูรณ์ ความถูกต้องตามกฎหมาย ความน่าเชื่อถือ ความเหมาะสมและความเป็นเจ้าของทรัพย์สินทางปัญญาทั้งหมดในข้อมูลหรือเอกสารอิเลคทรอนิคส์ใน Account (บัญชีผู้ใช้งาน) ของท่านหรือสิทธิในการใช้เนื้อหาที่นำส่งทั้งหมดถือเป็นทรัพย์สินของท่านแต่เพียงผู้เดียว บริษัทฯ อาจสังเกตการณ์และตรวจสอบเนื้อหาบน HubSwitch Pro ที่ท่านนำส่งหรือสร้างขึ้นโดยตัวท่าน การใช้งานเว็บไซต์โดยท่านไม่ถือเป็นการอนุญาตเราในการใช้ ทำซ้ำ ดัดแปลง แก้ไข เผยแพร่ หรือแจกจ่ายเนื้อหาที่ท่านสร้างขึ้นหรือจัดเก็บไว้ในบัญชีผู้ใช้ของท่านเพื่อการค้า การตลาด หรือวัตถุประสงค์อื่นใดที่มีคล้ายกัน เว้นแต่ท่านจะให้การอนุญาตแก่เราเป็นการเฉพาะ อย่างไรก็ตาม ท่านให้สิทธิแก่เราในการเข้าถึง คัดลอก แจกจ่าย จัดเก็บ ส่ง จัดรูปแบบใหม่และแสดงเนื้อหาของบัญชีผู้ใช้ของท่านตามที่กำหนดไว้สำหรับวัตถุประสงค์ในการให้บริการแก่ท่าน เราขอสงวนสิทธิ์ในการปฏิเสธหรือลบเนื้อหาใด ๆ ที่ละเมิดนโยบายของเรา ไม่เหมาะสม หรือเป็นอันตรายในทางใดทางหนึ่งต่อข้อกำหนดและเงื่อนไขฉบับนี้ตามดุลยพินิจของเราโดยไม่ต้องแจ้งให้ท่านทราบล่วงหน้า

</h6><h6>

8.3 ห้ามมิให้ผู้ใดทำการคัดลอก ทำซ้ำ มีสำเนา สำรองไว้ ทำเลียนแบบ ทำเหมือน ดัดแปลง ทำเพิ่ม เพื่อนำไปเผยแพร่ด้วยวัตถุประสงค์อื่นใด โดยปราศจากความยินยอมเป็นหนังสือจากบริษัทฯ ทั้งนี้ เว้นแต่จะได้มีการระบุกำหนดไว้ในข้อตกลงและ เงื่อนไข การใช้เนื้อหาโดยไม่ได้รับอนุญาตจากบริษัทฯ ให้ถือว่าเป็นการกระทำผิดในสาระสำคัญของข้อกำหนดและเงื่อนไขฉบับนี้และเป็นการละเมิดกฎหมายทรัพย์สินทางปัญญาซึ่งอาจทำให้ท่านถูกเรียกค่าเสียหายและได้รับบทลงโทษตามกฎหมาย

</h6><h6>

9. การใช้งานของบุคคลที่สามและข้อมูลของท่าน

</h6><h6>

หากท่านได้ทำการอนุญาตให้แอปพลิเคชันหรือซอฟต์แวร์ของบุคคลที่สามใช้งานร่วมกับการบริการที่ท่านได้รับบน HubSwitch Pro ท่านยอมรับว่า บริษัทฯ อาจอนุญาตให้ผู้ให้บริการของแอปพลิเคชันหรือซอฟต์แวร์ดังกล่าวเข้าถึงข้อมูลของท่านเท่าที่จำเป็นสำหรับการทำงานร่วมกันของแอปพลิเคชันหรือซอฟต์แวร์ดังกล่าวกับการบริการบน HubSwitch Pro ทั้งนี้ บริษัทฯ จะไม่รับผิดชอบต่อการเปิดเผย แก้ไข หรือลบข้อมูลใด ๆ ของท่านอันเกิดจากการเข้าถึงดังกล่าวโดยผู้ให้บริการทั้งสิ้น

</h6><h6>

10. การรับประกันและการยอมรับ

</h6><h6>

10.1 ท่านให้การรับประกันว่าที่ท่านได้ลงทะเบียนเพื่อใช้บริการในนามของบุคคลอื่น ท่านมีอำนาจที่จะยอมรับข้อกำหนดและเงื่อนไขฉบับนี้ในนามของบุคคลนั้นและยอมรับว่าการลงทะเบียนเพื่อใช้บริการ HubSwitch Pro นี้ ท่านได้ผูกพันบุคคลที่ท่านได้ดำเนินการแทนดังกล่าวและให้ปฏิบัติตามภาระผูกพันทั้งหลายทั้งปวงตามที่ท่านได้ทำไว้ภายใต้ข้อกำหนดและเงื่อนไขฉบับนี้
</h6><h6>
 

10.2 ท่านให้การรับประกันว่าท่านได้รับอนุญาตให้ใช้บริการและเว็บไซต์ และเข้าถึงข้อมูลและข้อมูลดิบที่ท่านป้อนลงในเว็บไซต์ รวมถึงข้อมูลใด ๆ หรือข้อมูลที่ป้อนลงในเว็บไซต์ โดยบุคคลใด ๆ ที่ท่านอนุญาตให้ใช้บริการ HubSwitch Pro บริษัทฯ จะไม่รับผิดชอบต่อบุคคลอื่นใดนอกจากท่าน ท่านยอมรับว่าท่านมีความรับผิดชอบต่อการอนุญาตให้บุคคลใด ๆ ผู้ซึ่งได้รับการอนุญาตให้เข้าถึงข้อมูลหรือข้อมูลดิบและท่านยอมรับว่า บริษัทฯ ไม่มีหน้าที่และความรับผิดชอบในการกระทำดังกล่าว
</h6><h6>
 

11. การระงับการให้บริการ
</h6><h6>
 

11.1 บริษัทฯ อาจระงับการให้บริการเป็นการชั่วคราว ด้วยเหตุความจำเป็นในบางประการที่บริษัทฯ ได้ตรวจพบและในกรณีที่มีการระงับบริการในประเภทที่มีค่าบริการ บริษัทฯ ขอสงวนสิทธิในการไม่คืนค่าบริการสำหรับระยะเวลาที่ระงับบริการดังกล่าวและถือว่า บริษัทฯ ไม่มีภาระผูกพันในการรับผิดชอบไม่ว่าด้วยเหตุผลใดก็ตาม
</h6><h6>
 

11.2 เหตุแห่งการระงับการให้บริการอาจรวมถึง
</h6><h6>
 

(1) การบำรุงรักษาอุปกรณ์ที่จำเป็นสำหรับการให้บริการ HubSwtich Pro
</h6><h6>
 

(2) อุปกรณ์ที่จำเป็นในการให้บริการไม่สามารถใช้งานได้
</h6><h6>
 

(3) เกิดเหตุในด้านการปฏิบัติการหรือด้านเทคนิคซึ่งส่งผลต่อการให้บริการ HubSwitch Pro
</h6><h6>
 

(4) การขัดข้องของระบบของบุคคลภายนอกที่ บริษัทฯ ใช้เป็นส่วนหนึ่งในการให้บริการ HubSwitch Pro
</h6><h6>
 

(5) การเกิดเหตุการณ์ที่เป็นอุปสรรคในการให้บริการ ยกตัวอย่างเช่น ไฟฟ้าขัดข้อง, ไฟไหม้, น้ำท่วม, ภัยธรรมชาติ, ภัยพิบัติต่าง ๆ, ความไม่สงบของเหตุการณ์บ้านเมือง, การนัดหยุดงาน หรือ เหตุสุดวิสัยอื่นใดที่อาจเกิดขึ้น
</h6><h6>
 

12. การยกเลิกข้อกำหนดและเงื่อนไขฉบับนี้

</h6><h6>

12.1 กรณีเลิกบริการที่ไม่มีค่าบริการ

</h6><h6>

เมื่อท่านลงทะเบียนสำหรับการเข้าถึงบริการของ HubSwitch Pro เป็นครั้งแรก ท่านสามารถใช้บริการภายใต้เงื่อนไขการทดลองใช้งานตามที่กำหนดไว้ได้ หากท่านเลือกที่จะใช้บริการต่อภายหลังจากการสิ้นสุดระยะเวลาทดลองใช้งานนั้น ท่านจะถูกเรียกเก็บเงินเมื่อท่านเพิ่มรายละเอียดการเรียกเก็บค่าบริการของท่านลงในบริการที่มีค่าบริการครั้งแรกโดยเป็นไปตามจำนวนที่ได้กำหนดไว้ในตารางอัตราค่าธรรมเนียมบนเว็บไซต์หรือ HubSwitch Pro ในระหว่างการทดลองใช้บริการท่านมีสิทธิยกเลิกการบริการได้โดยการส่งคำขอมายัง info@hubswitch.com

</h6><h6>

12.2 กรณีเลิกสัญญาประเภทมีค่าบริการ

</h6><h6>

ท่านมีสิทธิยกเลิกการใช้บริการได้โดยการส่งคำขอมายัง  info@hubswitch.com การยื่นคำขอดังกล่าวจะทำในเวลาใดก็ได้ก่อนสิ้นสุดระยะเวลาการใช้บริการโดยจะมีผลเป็นการยกเลิกการบริการสัญญาในวันสุดท้ายของรอบระยะเวลาการใช้บริการในปีที่ได้ยื่นคำขอเลิกการใช้บริการดังกล่าว ในกรณีที่ท่านมีความประสงค์จะยกเลิกบริการโดยให้มีผลในทันที (การปิด Account ก่อนสิ้นสุดระยะเวลาการใช้บริการ) บริษัทฯ สงวนสิทธิในการไม่คืนเงินค่าบริการที่ท่านได้ชำระไว้แล้วไม่ว่ากรณีใด ๆ ทั้งสิ้น

</h6><h6>

12.3 สิทธิในการเลิกสัญญาของ HubSwitch Pro

</h6><h6>

บริษัทฯ มีสิทธิบอกเลิกการบริการไม่ว่าในช่วงเวลาใด ๆ ก็ตาม ทั้งนี้ เมื่อ HubSwitch Pro ทำการบอกเลิกบริการแล้วให้ถือว่าการเลิกบริการมีผลในวันสุดท้ายของระยะเวลาการใช้บริการในปีที่ได้ทำการบอกเลิกโดยบริษัทฯ

</h6><h6>

13. ข้อจำกัดความรับผิด

</h6><h6>

บริษัทฯ ขอสงวนสิทธิ์ในการไม่รับผิดชอบต่อความเสียหายใด ๆ อันเกิดจากการใช้บริการหรือที่เกิดขึ้นจากความบกพร่องในการใช้บริการไม่ว่าด้วยเหตุใด ๆ โดยบริษัทฯ ขอสงวนสิทธิ์ในความรับผิดชอบสำหรับกรณีดังต่อไปนี้

</h6><h6>

13.1 บริษัทฯ จะไม่รับผิดชอบต่อความเสียหายใด ๆ ที่เกิดจากการใช้บริการ หรือที่เกิดขึ้นจากความบกพร่องในการใช้บริการไม่ว่าด้วยเหตุใด ๆ เว้นแต่ความเสียหายเกิดจากการจงใจหรือความประมาทประมาทเลินเล่ออย่างร้ายแรงของบริษัทฯ ทั้งนี้ ในกรณีดังกล่าว บริษัทฯ ขอจำกัดความรับผิดต่อค่าเสียหายที่แท้จริงที่เกิดขึ้นแก่ท่านไม่ว่าโดยตรงหรือโดยอ้อมสุงสุดไม่เกินอัตราค่าบริการที่ท่านได้ชำระให้แก่บริษัทฯ ปีที่เกิดเหตุการณ์ซึ่งทำให้เกิดค่าเสียหายนั้น

</h6><h6>

13.2 บริษัทฯ ไม่สามารถให้การรับประกันได้ว่าการใช้บริการของท่านจะปราศจากข้อบกพร่อง (ซึ่งรวมถึงแต่ไม่จำกัดเฉพาะ ความเสถียร, ความเชื่อถือได้, ความแม่นยำ, ความสมบูรณ์, ประสิทธิผล, ความเหมาะสมกับวัตถุประสงค์บางประการ, ความบกพร่องเกี่ยวกับความปลอดภัย, ข้อผิดพลาด, จุดบกพร่องของคอมพิวเตอร์ (bug) หรือ ไวรัส (virus)) ทั้งนี้ เนื่องด้วยระบบที่เกี่ยวข้องกับการให้บริการ ไม่ว่าจะเป็น ระบบการสื่อสาร ระบบคอมพิวเตอร์ หรือ อินเทอร์เน็ตนั้นย่อมมีความไม่แน่นอน อาจเกิดการรบกวนในการใช้บริการ HubSwitch Pro ได้

</h6><h6>

(1) บริษัทฯ จะไม่รับผิดชอบหากไม่สามารถให้บริการ HubSwitch Pro ได้ภายในระยะเวลาที่กำหนดไว้อันเนื่องมาจากเหตุสุดวิสัยที่มิอาจหลีกเลี่ยงได้

</h6><h6>

(2) บริษัทฯ จะไม่รับผิดชอบเกี่ยวกับการระงับหรือข้อบกพร่องในการใช้บริการ HubSwitch Pro เนื่องมาจากผลทางกฎหมายใดหรือการกระทำผิดกฎหมายของท่าน

</h6><h6>

14. ข้อกำหนดทั่วไป
</h6><h6>
 

14.1 ข้อตกลงทั้งหมด
</h6><h6>
 

ข้อกำหนดและเงื่อนไขฉบับนี้ นโยบายความเป็นส่วนตัวของบริษัทฯ ประกาศหรือคำสั่งอื่นที่ได้แจ้งให้ท่านทราบและเกี่ยวข้องกับการให้บริการ HubSwitch Pro จะแทนที่และระงับ ข้อตกลง การรับรอง (ไม่ว่าด้วยวาจาหรือเป็นลายลักษณ์อักษร) รวมถึงความเข้าใจก่อนหน้าทั้งหมด และกลายเป็นข้อตกลงทั้งหมดระหว่างท่านและ บริษัทฯ อันเกี่ยวข้องกับการบริการ HubSwitch Pro
</h6><h6>
 

14.2 การสละสิทธิ
</h6><h6>
 

หากฝ่ายหนึ่งฝ่ายใดสละสิทธิในการเรียกร้องค่าเสียหายจากการละเมิดหรือฝ่าฝืนข้อกำหนดข้อใดข้อหนึ่ง ของข้อกำหนดและเงื่อนไขฉบับนี้ จะไม่ถือว่าเป็นการสละสิทธิการเรียกร้องในการละเมิดข้ออื่น ๆ ที่เหลืออยู่ ทั้งนี้ การสละสิทธิจะมีผลก็ต่อเมื่อกระทำขึ้นเป็นลายลักษณ์อักษร
</h6><h6>
 

14.3 การโอนสิทธิ

</h6><h6>

ท่านไม่สามารถโอนสิทธิใด ๆ ที่ท่านมีภายใต้ข้อกำหนดและเงื่อนไขฉบับนี้ให้แก่บุคคลอื่นใด เว้นแต่จะได้รับความยินยอมเป็นลายลักษณ์อักษรจากบริษัทฯ ล่วงหน้า ทั้งนี้ บริษัทฯ สามารถโอนสิทธิภายใต้ข้อกำหนดและเงื่อนไขฉบับนี้ไปยังบุคคลอื่นได้ตามดุลยพินิจของบริษัทฯ แต่เพียงผู้เดียว

</h6><h6>

14.4 กฎหมายที่ใช้บังคับและเขตอำนาจศาล

</h6><h6>

ข้อกำหนดและเงื่อนไขฉบับนี้ให้ตีความและอยู่ภายใต้บังคับกฎหมายแห่งราชอาณาจักรไทย บรรดาข้อพิพาททั้งหมดที่เกิดขึ้นจากการใช้บริการ HubSwitch Pro หรือบริการอื่นใดที่เกี่ยวข้องของบริษัทฯ ที่ไม่สามารถยุติด้วยการเจรจาด้วยดีให้อยู่ภายใต้ขอบเขตอำนาจของศาลในราชอาณาจักรไทยเท่านั้นการแยกส่วนข้อตกลง

</h6><h6>

14.5 การแยกข้อตกลง

</h6><h6>

สิทธิและข้อจำกัดทั้งหมดที่มีอยู่ในข้อกำหนดและเงื่อนไขฉบับนี้อาจถูกใช้ มีผลบังคับใช้และมีผลผูกพัน เฉพาะในขอบเขตที่ข้อจำกัดนั้นไม่ละเมิดกฎหมายที่เกี่ยวข้องใด ๆ และตั้งใจที่จะจำกัดในขอบเขตที่จำเป็นเพื่อที่จะไม่ทำให้ข้อกำหนดและเงื่อนไขฉบับนี้ผิดกฎหมาย ไม่ถูกต้อง หรือไม่สามารถบังคับใช้ได้ หากข้อกำหนดและเงื่อนไขหรือส่วนใดส่วนหนึ่งของข้อกำหนดและเงื่อนไขฉบับนี้จะถือว่าผิดกฎหมายไม่ถูกต้องหรือไม่สามารถบังคับใช้ได้โดยศาลที่มีอำนาจ คู่สัญญาตกลงว่าข้อกำหนดและเงื่อนไขส่วนที่เหลือจะถือเป็นข้อกำหนดและเงื่อนไขที่ยังคงมีผลบังคับใช้อย่างสมบูรณ์

</h6><h6>

14.6 การบอกกล่าว

 
</h6><h6>
การบอกกล่าวล่วงหน้าใด ๆ ก็ตามภายใต้ข้อกำหนดและเงื่อนไขฉบับนี้โดยคู่สัญญาฝ่ายใดฝ่ายหนึ่งไปยังคู่สัญญาอีกฝ่ายจะต้องอยู่ในรูปแบบลายลักษณ์อักษรทางอีเมลและจะถือว่าได้รับเมื่อมีการส่งไปตามรายละเอียดที่ได้มีการระบุของแต่ละฝ่าย โดยท่านสามารถส่งอีเมลมาที่ info@hubswitch.com เพื่อทำการบอกกล่าวบริษัทฯ หรือที่อยู่อีเมลอื่น ๆ ที่บริษัทฯ แจ้งให้ท่านทราบโดยส่งไปยังที่อยู่อีเมล์ที่ท่านให้ไว้เมื่อมีการตั้งค่าการเข้าถึงบริการของท่าน
        </h6></>
    )
}